import { Box } from '@mui/material';

import { ConnectEmailPanel } from '@modules/_shared/components/email-connect/ConnectEmailPanel';
import { SlideDialog } from '@modules/_shared/components/SlideDialog';
import { useLocale } from '@shared/hooks/locale';

type Props = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onError: () => void;
};

export const ConnectEmailDialog = ({
  open,
  onClose,
  onSuccess,
  onError,
}: Props) => {
  const { t } = useLocale();

  return (
    <SlideDialog
      open={open}
      onClose={onClose}
      title={t('settingUpYourEmailWithRealAdvisor')}
      maxWidth="sm"
    >
      <Box sx={{ p: 2 }}>
        <ConnectEmailPanel onSuccess={onSuccess} onError={onError} />
      </Box>
    </SlideDialog>
  );
};
